
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '@/components/layouts/MainLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function EditReportNotFound() {
  const navigate = useNavigate();

  return (
    <MainLayout allowedRoles={['admin']}>
      <div className="flex flex-col items-center justify-center h-full">
        <h2 className="text-2xl font-bold mb-2">Report Not Found</h2>
        <p className="mb-4">The royalty report you're looking for doesn't exist.</p>
        <Button onClick={() => navigate('/admin/royalties')}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Reports
        </Button>
      </div>
    </MainLayout>
  );
}
